//Code by Felix Caraballo polycaravan.com
document.addEventListener('DOMContentLoaded', function() {
  observeDOMChanges();
  checkForStorePickupApp();
  observeTotalWeightChanges();
}, false);

function observeDOMChanges() {
  var targetNode = document.body;
  var config = { childList: true, subtree: true };

  var callback = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {
        var storePickupApp = document.querySelector('#storePickupApp');
        if (storePickupApp) {
          selectShipping(storePickupApp);
          hideShipping();
        }
      }
    }
  };

  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

function checkForStorePickupApp() {
  var intervalId = setInterval(function() {
    var storePickupApp = document.querySelector('#storePickupApp');
    if (storePickupApp) {
      selectShipping(storePickupApp);
      hideShipping();
      clearInterval(intervalId); // Stop checking once the element is found
    }
  }, 1000); // Check every second
}

function observeTotalWeightChanges() {
  var targetNode = document.querySelector('#total_raw_weight');
  if (!targetNode) {
    return;
  }
  var config = { childList: true, subtree: true, characterData: true };

  var callback = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        hideShipping();
      }
    }
  };

  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

function selectShipping(storePickupApp) {
  var shippingMethod = ".checkoutMethodName:contains('Shipping')";
  var element = $(storePickupApp).find(shippingMethod).parent();
  if (element.length) {
    element.attr('id', 'shippingMethod');
  }
}

function hideShipping() {
  var shipping = $('#shippingMethod');
  var totalWeight = parseInt($('#total_raw_weight').text());
  if (totalWeight < 15) {
    shipping.attr('style', 'display:none');
  } else {
    shipping.attr('style', 'display:block');
  }
}